import { createFileRoute } from '@tanstack/react-router'
import { ArmchairIcon } from 'lucide-react'

export const Route = createFileRoute('/_auth/_modules/_app/welcome')({
  staticData: {
    title: 'route.welcome',
    crumb: 'breadcrumbs.welcome',
    icon: ArmchairIcon,
  },
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
